import type { JSX } from 'react'
import { Grid, Typography } from '@mui/material'

import useSharedStyles from '../../utils/shared.styles'

import useStyles from './index.styles'

const IntroContainer = ({ title, subtitle, icon }: { title: string; subtitle?: string | JSX.Element; icon?: JSX.Element }) => {
  const sharedClasses = useSharedStyles
  const classes = useStyles

  return (
    <Grid sx={sharedClasses.introText} size={12}>
      <Typography variant="h5">{title}</Typography>
      {icon}

      {subtitle && (
        <Typography variant="body1" color="text.secondary" sx={classes.subtitle}>
          {subtitle}
        </Typography>
      )}
    </Grid>
  )
}

export default IntroContainer
